import React, { useState, useEffect, useMemo } from "react";
import { Global } from "../helpers/Global";
import Select from "react-select";

export const DepartamentosAdmin = () => {
  const [departamentos, setDepartamentos] = useState([]);
  const [usuariosSistema, setUsuariosSistema] = useState([]);
  const [mostrarDeptosDesactivados, setMostrarDeptosDesactivados] = useState(false);

  const [deptoExpandidoId, setDeptoExpandidoId] = useState(null);
  const [usuariosPorDepartamento, setUsuariosPorDepartamento] = useState({}); // { [idDepto]: usuarios[] }

  // Modal edición departamento
  const [modalEditarDepto, setModalEditarDepto] = useState(false);
  const [deptoEditando, setDeptoEditando] = useState(null);
  const [editNombre, setEditNombre] = useState("");
  const [editDescripcion, setEditDescripcion] = useState("");

  // Modal "Añadir usuario a departamento"
  const [mostrarModalUsuario, setMostrarModalUsuario] = useState(false);
  const [deptoParaUsuario, setDeptoParaUsuario] = useState(null);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [rolUsuarioDepto, setRolUsuarioDepto] = useState("miembro");
  const [addUserCargando, setAddUserCargando] = useState(false);
  const [addUserMsg, setAddUserMsg] = useState("");

  const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  });

  // -------- helpers avatar (reutilizados) --------
  const getAvatarUrl = (usuario) => {
    if (!usuario?.avatar_url) return null;
    return `${Global.url}${usuario.avatar_url}`;
  };

  const getIniciales = (usuario) => {
    const nombre = (usuario?.nombre || "").trim();
    const apellidos = (usuario?.apellidos || "").trim();
    const n1 = nombre ? nombre.split(" ")[0][0] : "";
    const a1 = apellidos ? apellidos.split(" ")[0][0] : "";
    const combo = (n1 + a1).toUpperCase();
    if (combo) return combo;
    if (nombre) return nombre[0].toUpperCase();
    return "?";
  };

  // Cargar departamentos y usuarios del sistema al inicio
  useEffect(() => {
    fetchDepartamentos();
    fetchUsuariosSistema();
  }, []);

  const fetchDepartamentos = async () => {
    try {
      // Pedimos también inactivos y filtramos en front
      const res = await fetch(`${Global.url}departamentos?incluirInactivos=true`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await res.json();
      setDepartamentos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
      alert("Error al cargar departamentos.");
    }
  };

  const fetchUsuariosSistema = async () => {
    try {
      const res = await fetch(`${Global.url}usuarios/todos`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await res.json();
      setUsuariosSistema(Array.isArray(data) ? data.filter((u) => u.activo !== false) : []);
    } catch (error) {
      console.error("Error al obtener usuarios del sistema:", error);
    }
  };

  const fetchUsuariosDepartamento = async (departamentoId) => {
    try {
      const res = await fetch(`${Global.url}departamentos/${departamentoId}/usuarios`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await res.json();
      setUsuariosPorDepartamento((prev) => ({
        ...prev,
        [departamentoId]: Array.isArray(data) ? data : [],
      }));
    } catch (error) {
      console.error("Error al obtener usuarios del departamento:", error);
      alert("Error al cargar usuarios del departamento.");
    }
  };

  const toggleUsuarios = (departamentoId) => {
    setDeptoExpandidoId((prev) => {
      const nuevo = prev === departamentoId ? null : departamentoId;
      if (nuevo && !usuariosPorDepartamento[nuevo]) {
        fetchUsuariosDepartamento(nuevo);
      }
      return nuevo;
    });
  };

  const eliminarDepartamento = async (departamentoId) => {
    if (!window.confirm("¿Eliminar (desactivar) este departamento?")) return;
    try {
      const res = await fetch(`${Global.url}departamentos/${departamentoId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.ok) {
        await fetchDepartamentos();
        alert("Departamento desactivado correctamente.");
      } else {
        alert("Error al desactivar el departamento.");
      }
    } catch {
      alert("Error de red al desactivar el departamento.");
    }
  };

  const reactivarDepartamento = async (departamentoId) => {
    if (!window.confirm("¿Reactivar este departamento?")) return;
    try {
      const res = await fetch(`${Global.url}departamentos/${departamentoId}`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({ activo: true }),
      });
      if (res.ok) {
        await fetchDepartamentos();
        alert("Departamento reactivado correctamente.");
      } else {
        const data = await res.json();
        alert(data.message || "Error al reactivar el departamento.");
      }
    } catch {
      alert("Error de red al reactivar el departamento.");
    }
  };

  const abrirModalEditarDepto = (departamento) => {
    setDeptoEditando(departamento);
    setEditNombre(departamento.nombre || "");
    setEditDescripcion(departamento.descripcion || "");
    setModalEditarDepto(true);
  };

  const guardarCambiosDepto = async () => {
    if (!deptoEditando) return;
    try {
      const res = await fetch(`${Global.url}departamentos/${deptoEditando.id}`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({
          nombre: editNombre,
          descripcion: editDescripcion,
        }),
      });
      if (res.ok) {
        await fetchDepartamentos();
        setModalEditarDepto(false);
        setDeptoEditando(null);
      } else {
        alert("❌ Error al guardar los cambios del departamento");
      }
    } catch (err) {
      console.error("Error al guardar departamento:", err);
      alert("❌ Error de red al guardar");
    }
  };

  const quitarUsuarioDeDepartamento = async (departamentoId, usuarioId) => {
    if (!window.confirm("¿Quitar este usuario del departamento?")) return;
    try {
      const res = await fetch(`${Global.url}departamentos/${departamentoId}/usuarios/${usuarioId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.ok) {
        await fetchUsuariosDepartamento(departamentoId);
      } else {
        alert("Error al quitar usuario del departamento.");
      }
    } catch {
      alert("Error de red al quitar usuario.");
    }
  };

  // 👉 Abrir modal "Añadir usuario"
  const abrirModalAgregarUsuario = (departamento) => {
    setDeptoParaUsuario(departamento);
    setUsuarioSeleccionado(null);
    setRolUsuarioDepto("miembro");
    setAddUserMsg("");
    setMostrarModalUsuario(true);
  };

  const cerrarModalAgregarUsuario = () => {
    setMostrarModalUsuario(false);
    setDeptoParaUsuario(null);
    setUsuarioSeleccionado(null);
    setRolUsuarioDepto("miembro");
    setAddUserCargando(false);
    setAddUserMsg("");
  };

  // Usuarios disponibles para el departamento actualmente seleccionado en el modal
  const usuariosDisponibles = useMemo(() => {
    const deptId = deptoParaUsuario?.id;
    if (!deptId) return [];
    const yaAsignados = new Set((usuariosPorDepartamento[deptId] || []).map((u) => u.id));
    return usuariosSistema
      .filter((u) => !yaAsignados.has(u.id))
      .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
  }, [deptoParaUsuario, usuariosPorDepartamento, usuariosSistema]);

  // Opciones para react-select
  const usuarioOptions = useMemo(
    () =>
      usuariosDisponibles.map((u) => ({
        value: String(u.id),
        label: `${u.nombre || ""} ${u.apellidos || ""} (${u.email || u.dni || "s/d"})`.trim(),
      })),
    [usuariosDisponibles]
  );

  const agregarUsuarioADepartamento = async () => {
    if (!deptoParaUsuario || !usuarioSeleccionado) {
      setAddUserMsg("Selecciona un usuario antes de guardar.");
      return;
    }

    setAddUserCargando(true);
    setAddUserMsg("");

    try {
      const usuarioId = Number(usuarioSeleccionado.value);
      const res = await fetch(`${Global.url}departamentos/${deptoParaUsuario.id}/usuarios`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          usuarios: [{ usuario_id: usuarioId, rol: rolUsuarioDepto }],
        }),
      });

      if (!res.ok) {
        setAddUserMsg("Error al agregar usuario al departamento.");
        return;
      }

      await fetchUsuariosDepartamento(deptoParaUsuario.id);
      cerrarModalAgregarUsuario();
    } catch (e) {
      console.error(e);
      setAddUserMsg("Error de red al agregar usuario.");
    } finally {
      setAddUserCargando(false);
    }
  };

  return (
    <>
      <div className="filtros">
        <label>
          <input
            type="checkbox"
            checked={mostrarDeptosDesactivados}
            onChange={(e) => setMostrarDeptosDesactivados(e.target.checked)}
          />
          Mostrar departamentos desactivados
        </label>
      </div>

      <div className="tabla-clientes">
        <h2>Gestión de Departamentos</h2>

        <table className="tabla-listado-clientes">
          <thead>
            <tr>
              <th>Departamento</th>
              <th>Descripción</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {departamentos
              .filter((d) => d.activo || mostrarDeptosDesactivados)
              .map((d) => (
                <React.Fragment key={d.id}>
                  {/* FILA PRINCIPAL DEL DEPARTAMENTO */}
                  <tr>
                    <td>{d.nombre}</td>
                    <td>{d.descripcion || "-"}</td>
                    <td>{d.activo ? "Activo" : "Inactivo"}</td>
                    <td className="acciones-columna">
                      <button onClick={() => toggleUsuarios(d.id)}>
                        {deptoExpandidoId === d.id ? "Ocultar Usuarios" : "Mostrar Usuarios"}
                      </button>

                      <button onClick={() => abrirModalEditarDepto(d)}>Editar</button>
                      <button onClick={() => abrirModalAgregarUsuario(d)}>Añadir Usuario</button>

                      {d.activo ? (
                        <button onClick={() => eliminarDepartamento(d.id)}>Eliminar</button>
                      ) : (
                        <button onClick={() => reactivarDepartamento(d.id)}>Reactivar</button>
                      )}
                    </td>
                  </tr>

                  {/* SUBTABLA DE USUARIOS DEL DEPARTAMENTO */}
                  {deptoExpandidoId === d.id && (
                    <tr>
                      <td colSpan="4" style={{ padding: 0 }}>
                        <table className="subtabla-centros subtabla-centros--usuarios">
                          <thead>
                            <tr>
                              <th className="th-avatar" style={{ width: "56px" }}></th>
                              <th>Usuario</th>
                              <th>Email</th>
                              <th>Rol</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>

                          <tbody>
                            {(usuariosPorDepartamento[d.id] || []).length === 0 ? (
                              <tr>
                                <td colSpan={5} style={{ fontStyle: "italic" }}>
                                  No hay usuarios en este departamento.
                                </td>
                              </tr>
                            ) : (
                              (usuariosPorDepartamento[d.id] || []).map((u) => (
                                <tr key={u.id}>

                                  {/* AVATAR */}
                                  <td className="td-avatar">
                                    <div className="avatar-lista">
                                      {getAvatarUrl(u) ? (
                                        <img
                                          src={getAvatarUrl(u)}
                                          alt={`${u.nombre || ""} ${u.apellidos || ""}`}
                                        />
                                      ) : (
                                        <div className="avatar-fallback">
                                          {getIniciales(u)}
                                        </div>
                                      )}
                                    </div>
                                  </td>

                                  {/* NOMBRE + APELLIDOS */}
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    {`${u.nombre || ""} ${u.apellidos || ""}`.trim()}
                                  </td>

                                  <td>{u.email || "-"}</td>
                                  <td>{u.rol || "miembro"}</td>

                                  {/* ACCIONES */}
                                  <td className="acciones-columna">
                                    {u.miembro_activo !== false ? (
                                      <button
                                        onClick={() =>
                                          quitarUsuarioDeDepartamento(d.id, u.id)
                                        }
                                      >
                                        Quitar
                                      </button>
                                    ) : (
                                      <span style={{ fontStyle: "italic" }}>Inactivo</span>
                                    )}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
          </tbody>
        </table>


        {/* MODAL: Editar Departamento */}
        {modalEditarDepto && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button
                className="modal-close"
                onClick={() => setModalEditarDepto(false)}
              >
                &times;
              </button>
              <h3>Editar Departamento #{deptoEditando?.id}</h3>

              <label>Nombre:</label>
              <input
                value={editNombre}
                onChange={(e) => setEditNombre(e.target.value)}
              />

              <label>Descripción:</label>
              <textarea
                value={editDescripcion}
                onChange={(e) => setEditDescripcion(e.target.value)}
                rows={3}
              />

              <button className="btn-login" onClick={guardarCambiosDepto}>
                💾 Guardar Cambios
              </button>
            </div>
          </div>
        )}

        {/* MODAL: Añadir Usuario a Departamento */}
        {mostrarModalUsuario && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="modal-close" onClick={cerrarModalAgregarUsuario}>
                &times;
              </button>
              <h3>Añadir usuario a “{deptoParaUsuario?.nombre}”</h3>

              {addUserMsg && <div className="alerta">{addUserMsg}</div>}

              <label>Usuario:</label>
              <Select
                isSearchable
                isClearable
                classNamePrefix="select"
                placeholder="Buscar usuario…"
                options={usuarioOptions}
                value={usuarioSeleccionado}
                onChange={(opt) => setUsuarioSeleccionado(opt || null)}
                menuPortalTarget={document.body}
              />

              <label style={{ marginTop: 8 }}>Rol:</label>
              <select
                className="input-layout"
                value={rolUsuarioDepto}
                onChange={(e) => setRolUsuarioDepto(e.target.value)}
              >
                <option value="miembro">Miembro</option>
                <option value="responsable">Responsable</option>
                <option value="backup">Backup</option>
              </select>

              <button
                className="btn-login"
                style={{ marginTop: 12 }}
                onClick={agregarUsuarioADepartamento}
                disabled={addUserCargando || !usuarioSeleccionado}
              >
                {addUserCargando ? "Guardando..." : "Añadir Usuario"}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
